import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

import CollectionsBreadcrumbs from '../Collections/Breadcrumbs';
import FileExtension from '../File/Extension';
import FileResolution from '../File/Resolution';
import FileSize from '../File/Size';

const SearchSelectItem = (props) => {
  const { data } = props;

  if (data.type === 'files_archived' || data.type === 'collections_archived') {
    return null;
  }

  return (
    <components.Option {...props}>
      <div className="search-input-item">
        <div className="search-input-image">
          <img
            className={`${data.type}-item-img`}
            src={data.urls.thumbnail}
            srcSet={`${data.urls.thumbnail} 1x, ${data.urls.thumbnailx2} 2x`}
            alt={data.label}
          />
        </div>
        <div className="search-input-body">
          <h6 className="search-input-title">
            {data.label}
          </h6>
          {(data.type === 'collection' && data.ancestors?.length > 0) && (
            <span className="search-input-details collection-details">
              <div>
                <CollectionsBreadcrumbs collection={data} inSearch={true} />
              </div>
            </span>
          )}
          {data.type === 'file' && (
            <span className="search-input-details file-details">
              <div>
                <FileResolution
                  file={data}
                />
                <FileExtension
                  file={data}
                />
                <FileSize
                  file={data}
                />
              </div>
            </span>
          )}
        </div>
      </div>
    </components.Option>
  );
};

SearchSelectItem.propTypes = {
  data: PropTypes.object.isRequired,
  innerProps: PropTypes.object.isRequired,
};

export default SearchSelectItem;
